import {debounce, get, xor} from 'helpers';
import {store} from 'store';
import {set} from 'store/settings/actions_legacy';

export function signIn(_, form) {
  store.dispatch({
    type: 'GOOGLE_CALENDAR_SIGN_IN',
    finally: get(form, 'resetForm'),
  });
}

export function signOut(_, form) {
  store.dispatch({
    type: 'GOOGLE_CALENDAR_SIGN_OUT',
    finally: get(form, 'resetForm'),
    initiated: 'user',
  });
}

export function toggleCalendar(id) {
  set({
    module: 'googleCalendar',
    key: 'importCalendars',
    value: current => xor(current, [id])
  });
  fetchEvents();
}

export function deleteImportedEvents({ id }) {
  store.dispatch({
    type: 'GOOGLE_CALENDAR_DELETE_IMPORTED_EVENTS',
    id
  });
}

export const fetchEvents = debounce(() => {
  store.dispatch({ type: 'GOOGLE_CALENDAR_READ' });
}, 1000);

export const fetchCalendars = debounce(() => {
  store.dispatch({ type: 'GOOGLE_CALENDAR_GET_CALENDARS' });
}, 1000);

